
/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * Content management API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  ContentView,
  CookiesView,
} from '../models';
import {
    ContentViewFromJSON,
    ContentViewToJSON,
    CookiesViewFromJSON,
    CookiesViewToJSON,
} from '../models';

export interface CookiesConsentWithOneTrustVersionRequest {
    version: string;
}

export interface CookiesForVersionRequest {
    version: string;
}

export interface PolicyForVersionRequest {
    version: string;
}

export interface PrivacyForVersionRequest {
    version: string;
}

export interface RightsForVersionRequest {
    version: string;
}

/**
 * 
 */
export class PrivacyApiApi extends runtime.BaseAPI {

    /**
          */
    async cookiesRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ContentView>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ContentView>({
            path: `/cms/api/cookies`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ContentViewFromJSON(response._data); }
        return response;
    }

    /**
          */
    async cookies(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ContentView> {
        const response = await this.cookiesRaw(initOverrides);
        return response._data;
    }

    /**
          */
    async cookiesConsentWithOneTrustRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<CookiesView>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<CookiesView>({
            path: `/cms/api/cookies-one-trust`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=CookiesViewFromJSON(response._data); }
        return response;
    }

    /**
          */
    async cookiesConsentWithOneTrust(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<CookiesView> {
        const response = await this.cookiesConsentWithOneTrustRaw(initOverrides);
        return response._data;
    }

    /**
          */
    async cookiesConsentWithOneTrustVersionRaw(requestParameters: CookiesConsentWithOneTrustVersionRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<CookiesView>> {
        if (requestParameters['version'] == null) {
            throw new runtime.RequiredError(
                'version',
                'Required parameter "version" was null or undefined when calling cookiesConsentWithOneTrustVersion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<CookiesView>({
            path: `/cms/api/cookies-one-trust/{version}`.replace(`{${"version"}}`, encodeURIComponent(String(requestParameters['version']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=CookiesViewFromJSON(response._data); }
        return response;
    }

    /**
          */
    async cookiesConsentWithOneTrustVersion(requestParameters: CookiesConsentWithOneTrustVersionRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<CookiesView> {
        const response = await this.cookiesConsentWithOneTrustVersionRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
          */
    async cookiesForVersionRaw(requestParameters: CookiesForVersionRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ContentView>> {
        if (requestParameters['version'] == null) {
            throw new runtime.RequiredError(
                'version',
                'Required parameter "version" was null or undefined when calling cookiesForVersion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ContentView>({
            path: `/cms/api/cookies/{version}`.replace(`{${"version"}}`, encodeURIComponent(String(requestParameters['version']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ContentViewFromJSON(response._data); }
        return response;
    }

    /**
          */
    async cookiesForVersion(requestParameters: CookiesForVersionRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ContentView> {
        const response = await this.cookiesForVersionRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
          */
    async policyRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ContentView>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ContentView>({
            path: `/cms/api/policy`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ContentViewFromJSON(response._data); }
        return response;
    }

    /**
          */
    async policy(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ContentView> {
        const response = await this.policyRaw(initOverrides);
        return response._data;
    }

    /**
          */
    async policyForVersionRaw(requestParameters: PolicyForVersionRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ContentView>> {
        if (requestParameters['version'] == null) {
            throw new runtime.RequiredError(
                'version',
                'Required parameter "version" was null or undefined when calling policyForVersion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ContentView>({
            path: `/cms/api/policy/{version}`.replace(`{${"version"}}`, encodeURIComponent(String(requestParameters['version']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ContentViewFromJSON(response._data); }
        return response;
    }

    /**
          */
    async policyForVersion(requestParameters: PolicyForVersionRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ContentView> {
        const response = await this.policyForVersionRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
          */
    async privacyRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ContentView>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ContentView>({
            path: `/cms/api/privacy`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ContentViewFromJSON(response._data); }
        return response;
    }

    /**
          */
    async privacy(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ContentView> {
        const response = await this.privacyRaw(initOverrides);
        return response._data;
    }

    /**
          */
    async privacyForVersionRaw(requestParameters: PrivacyForVersionRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ContentView>> {
        if (requestParameters['version'] == null) {
            throw new runtime.RequiredError(
                'version',
                'Required parameter "version" was null or undefined when calling privacyForVersion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ContentView>({
            path: `/cms/api/privacy/{version}`.replace(`{${"version"}}`, encodeURIComponent(String(requestParameters['version']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ContentViewFromJSON(response._data); }
        return response;
    }

    /**
          */
    async privacyForVersion(requestParameters: PrivacyForVersionRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ContentView> {
        const response = await this.privacyForVersionRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
          */
    async rightsRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ContentView>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ContentView>({
            path: `/cms/api/rights`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ContentViewFromJSON(response._data); }
        return response;
    }

    /**
          */
    async rights(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ContentView> {
        const response = await this.rightsRaw(initOverrides);
        return response._data;
    }

    /**
          */
    async rightsForVersionRaw(requestParameters: RightsForVersionRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ContentView>> {
        if (requestParameters['version'] == null) {
            throw new runtime.RequiredError(
                'version',
                'Required parameter "version" was null or undefined when calling rightsForVersion().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ContentView>({
            path: `/cms/api/rights/{version}`.replace(`{${"version"}}`, encodeURIComponent(String(requestParameters['version']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ContentViewFromJSON(response._data); }
        return response;
    }

    /**
          */
    async rightsForVersion(requestParameters: RightsForVersionRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ContentView> {
        const response = await this.rightsForVersionRaw(requestParameters, initOverrides);
        return response._data;
    }

}
